import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import subDays from 'date-fns/subDays'
// const [range, setRange] = useState<[Date | undefined, Date | undefined]>([
//   subDays(todayRef.current, 60),
//   todayRef.current,
// ])

interface ChartStore {
  disabledExerciseIds: Array<{ id: number; name: string }>
  disableExerciseId: (id: number, name: string) => void
  batchDisableExerciseIds: (ids: { id: number; name: string }[]) => void
  enableExerciseId: (id: number) => void
  clearDisabled: () => void

  range: [Date | undefined, Date | undefined]
  setRange: (range: [Date | undefined, Date | undefined]) => void
}

export const useChartStore = create<ChartStore>()(
  persist(
    (set) => {
      const today = new Date()
      return {
        disabledExerciseIds: [],
        disableExerciseId: (id: number, name: string) => {
          set((state) => {
            return {
              ...state,
              disabledExerciseIds: [...state.disabledExerciseIds, { id, name }],
            }
          })
        },
        batchDisableExerciseIds: (ids: { id: number; name: string }[]) => {
          set((state) => {
            return {
              ...state,
              disabledExerciseIds: ids,
            }
          })
        },
        enableExerciseId: (id: number) => {
          set((state) => {
            return {
              ...state,
              disabledExerciseIds: state.disabledExerciseIds.filter(
                (o) => o.id !== id
              ),
            }
          })
        },
        clearDisabled: () => {
          set((state) => {
            return {
              ...state,
              disabledExerciseIds: [],
            }
          })
        },

        range: [subDays(today, 60), today],
        setRange: (range: [Date | undefined, Date | undefined]) => {
          set((state) => {
            return {
              ...state,
              range,
            }
          })
        },
      }
    },
    {
      name: 'stats',
      version: 5,
    }
  )
)
